import { render, staticRenderFns } from "./MatterProgramView.vue?vue&type=template&id=d7dd4844&scoped=true"
import script from "./MatterProgramView.vue?vue&type=script&lang=js"
export * from "./MatterProgramView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dd4844",
  null
  
)

export default component.exports